/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_Usage_DescInputs */

const en_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Feature usage, analytics events — Legal basis: Consent (Art. 6(1)(a) GDPR)`)
};

const de_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Funktionsnutzung, Analyseereignisse — Rechtsgrundlage: Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)`)
};

const fr_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Utilisation des fonctionnalités, événements d'analyse (avec consentement)`)
};

const es_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Uso de funcionalidades, eventos de análisis (con consentimiento)`)
};

const it_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Utilizzo delle funzionalità, eventi analitici (con consenso)`)
};

const nl_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Functiegebruik, analytics-evenementen (met toestemming)`)
};

const pl_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Użytkowanie funkcji, zdarzenia analityczne (za zgodą)`)
};

const fi_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Ominaisuuksien käyttö, analytiikkatapahtumat (suostumuksella)`)
};

const da_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Funktionsbrug, analyseevents (med samtykke)`)
};

const sv_privacy_data_processing_item_usage_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Funktionsanvändning, analyshändelser (med samtycke)`)
};

/**
* | output |
* | --- |
* | "Feature usage, analytics events — Legal basis: Consent (Art. 6(1)(a) GDPR)" |
*
* @param {Privacy_Data_Processing_Item_Usage_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_usage_desc = /** @type {((inputs?: Privacy_Data_Processing_Item_Usage_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_Usage_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "es") return es_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "it") return it_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "da") return da_privacy_data_processing_item_usage_desc(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_usage_desc(inputs)
	return en_privacy_data_processing_item_usage_desc(inputs)
});